export default "__VITE_ASSET__CYFqObDZ__"